import { all, call, put, takeLatest } from "redux-saga/effects";
import {
  getBirthdayDataStart,
  getBirthdayDataSuccess,
  getBirthdayDataFailed,
} from "../redux/getBirthdayData";
import { getListBirthdayAPI } from "core/http/service/birthday";

function* getBirthdayDataWork(action) {
  try {
    const payload = action.payload;
    const res = yield call(getListBirthdayAPI, payload);

    yield put({ type: getBirthdayDataSuccess.type, payload: res.list });
  } catch (error: any) {
    yield put({ type: getBirthdayDataFailed.type });
  }
}

function* watchGetBirthdayData() {
  yield takeLatest(getBirthdayDataStart.type, getBirthdayDataWork);
}

export default function* getBirthdayDataSaga() {
  yield all([watchGetBirthdayData()]);
}
